import React, { Suspense, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
// import VideoPlayerModal from '../common/VideoPlayerModal';
const VideoPlayerModal = React.lazy(() => import('../common/VideoPlayerModal'));


const VirtualWorlds = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }
  return (
    <>
         <Card className='text-center no-border rounded-0 container virtual-worlds-container pb-md-5'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'>Virtual (VR) Worlds (a.k.a the Metaverse)</Card.Title>
                <Card.Text className='industrial-environment-text'>
                From the dawn of consumer VR and founding of Paracosma in 2016, we have experimented with the creation and use of multi-user virtual worlds. We have tried, explored, and developed for nearly every platform, from Altspace VR to VR Chat, Fortnite to Roblox, Engage VR to EON Reality. <br /><br /> At the outset of the pandemic, we immediately created our own virtual offices and auditorium for internal company meetings, presentations and events, and have hosted numerous networking events in our virtual offices in combination with other virtual conferences.
                </Card.Text>
                
            </Card.Body>
            <Row className='pt-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card.Title className='vr-healthcare-title'>Paracosma Virtual Office</Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    Our virtual office, includes meeting and conference rooms, an auditorium, and awesome San Francisco views.
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/paracosma-office/po_001.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/paracosma-office/images/paracosma-office-banner.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                    </Card>
                </Col>
            </Row>
        </Card>

        <div className="paracosma-slideshow d-none d-md-block">
            <div className="paracosma-image-mover"></div>
        </div>

        <div className="paracosma-mobile-slideshow d-sm-block d-md-none">
            <div className="paracosma-mobile-image-mover"></div>
        </div>

        <Card className='no-border rounded-0 virtual-world-container'>
            <Card.Body>
                <Card.Title className='virtual-world-gallery-title'>Virtual Worlds and Events Video Gallery</Card.Title>
            </Card.Body>
            <Row className='pt-md-2'>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/virtual-world-gallery/videos/vwg_004.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/virtual-world-gallery/images/vwg_004.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'>Tokushima Movie Festival</Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/virtual-world-gallery/videos/vwg_001.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/virtual-world-gallery/images/vwg_001.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'>Lloyds Office Boxes</Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/virtual-world-gallery/videos/vwg_002.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/virtual-world-gallery/images/vwg_002.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'>Amazon VR Store</Card.Title>
                    </Card>
                </Col>

                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="no-padding-x pb-md-5">
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/virtual-world-gallery/videos/vwg_003.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/virtual-world-gallery/images/vwg_003.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>
                        <Card.Title className='vr-worlds-footer-title'>Pashupatinath Temple</Card.Title>
                    </Card>
                </Col>

            </Row>
        </Card>
        
        <Suspense fallback={<div>Loading...</div>}>
            <VideoPlayerModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            videosrc={videoUrl}
            />
        </Suspense>
    </>
  )
}

export default VirtualWorlds
